import React, { useState } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { useAccount, useContractWrite, useNetwork, useWaitForTransaction } from "wagmi";
import { parseEther } from "viem";
import { tokenAbi } from "../constants/tokenAbi";
import { toast } from "react-toastify";
import { abi } from "../constants/abi";
const Home = () => {

  const { isConnected } = useAccount();
  const { chain } = useNetwork();

  const [amount, setAmount] = useState('')

  let data = ["0x9f9e10074f595A11e88a6b829d6594a55bD54F3A", amount.length > 0 && amount !== "." ? parseEther(amount).toString() : "0"];

  const { write: approveTokenWrite, data: approveTokenData } = useContractWrite(
    {
      address: "0xd57cfb45347573f4f2471fa1572eb79d0ba29fd0",
      abi: tokenAbi,
      functionName: 'approve',
      args: data,
      onError: (error) => {
        var str = JSON.stringify(error)
        var obj = JSON.parse(str)
        var reason = obj.cause.reason
        reason ? toast.error(`${reason}`) : toast.error(`${obj?.details}`)

      }
    }
  )

  const { write: buyTokenWrite, data: buyTokenData } = useContractWrite(
    {
      address: "0x9f9e10074f595A11e88a6b829d6594a55bD54F3A",
      abi: abi,
      functionName: 'swap',
      args: [amount.length > 0 && amount !== "." ? parseEther(amount).toString() : "0"
      ],
      onError: (error) => {
        var str = JSON.stringify(error)
        var obj = JSON.parse(str)
        var reason = obj.cause.reason
        reason ? toast.error(`${reason}`) : toast.error(`${obj?.details}`)

      }
    }
  )

  const approveTokenWait = useWaitForTransaction({
    hash: approveTokenData?.hash,
    onSuccess() {
      buyTokenWrite();
    }
  })

  const buyTokenWait = useWaitForTransaction({
    hash: buyTokenData?.hash,
    onSuccess() {
      toast.success(`Old Safo Tokens Swapped Successfully`)
    }
  })

  return (
    <div className="overflow-y-hidden">

      <Header />

      <p className="text-center text-lyellow text-2xl font-semibold mt-3">Safo Swap</p>

      <div className="w-full h-[70vh] flex-col flex items-center justify-center">
        <div className="flex justify-center mb-2">
          <p className="text-lyellow text-lg font-semibold w-[40%]">
            Enter Old Safo Tokens Amount To Swap
          </p>
          <input
            type="text"
            placeholder="Enter Amout here "
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="text-black border-lyellow border-2 rounded-xl px-4 h-7 text-sm w-[50%]"
          />
        </div>
        <div className="flex justify-start items-center">
          <button
            className={`bg-lyellow text-sm font-semibold mt-2 py-2 px-4 text-whit rounded-lg text-white`}
            onClick={() => {
              if (amount.length > 0 && amount !== ".") {
                if (isConnected) {
                  if (chain?.id == 56) {
                    approveTokenWrite()
                  } else {
                    toast.error("Connect BSC Network")
                  }
                } else {
                  toast.error("Connect Wallet First")
                }
              } else {
                toast.error("Enter Amount First")
              }
            }}
          >
            Swap Tokens
          </button>
        </div>
        <div>

        </div>
      </div>


      <Footer />
    </div>
  );
};

export default Home;
